const checkUserType = (userType) => {
	let allUserTypes = JSON.parse(localStorage.getItem('userInfo'))?.allUserTypes;
	return allUserTypes?.includes(userType);
};

const HTTP_STATUS = {
	OK: 200,
	'Bad Request': 400,
	Unauthorized: 401,
	Forbidden: 403,
	'Not Found': 404,
	'Method Not Allowed': 405,
	'Not Acceptable': 406,
	'Request Time-out': 408,
	Conflict: 409,
	Gone: 410,
	'Unsupported Media Type': 415,
	'Expectation Failed': 417,
	'Precondition Required': 428,
	'Valid OTP Exists': 452
};

export const BASE_URL = getBaseUrl(); //Live
export const BASE_FRONT_END_URL = getBaseFrontEndUrl();
export const BASE_AI_URL = getAiBaseUrl();

export const LOADER_OVERLAY_BACKGROUND = 'transparent';
export const LOADER_COLOR = '#452D8D';
export const LOADER_WIDTH = '80px';
export const LOADER_TEXT = ''; //temporarily removed
export const LOADER_POSITION = 'fixed';
export const LOADER_TOP = '50%';
export const LOADER_LEFT = '50%';
export const LOADER_MARGIN_TOP = -100;
export const LOADER_MARGIN_LEFT = 0;
export const SURVEYSPARROW_TOKEN =
	'pr_upQBJ3jS1ZomrjHJ4BRNUP3_dCjeJWON2HZaumJk_lp5x3lsuu3UtK7BbT9-nSRZit-_0KaBSlfXGwanBKJ5w';

export const hjid = getHotjarId();
export const hjsv = 6;

function getHotjarId() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 2748605;
	} else {
		return 2748605;
	}
}

export const PERMISSIONS = {
	COSTING_SHEET_ADD_FABRIC: 'COSTING_SHEET_ADD_FABRIC',
	COSTING_SHEET_ADD_QUANTITY: 'COSTING_SHEET_ADD_QUANTITY',
	COSTING_SHEET_APPROVE_OFFER: 'COSTING_SHEET_APPROVE_OFFER',
	COSTING_SHEET_GET: 'COSTING_SHEET_GET',
	COSTING_SHEET_DOWNLOAD: 'COSTING_SHEET_DOWNLOAD',
	COSTING_SHEET_PLACE_ORDER: 'COSTING_SHEET_PLACE_ORDER',
	COSTING_SHEET_REQUEST_FOR_RECOSTING: 'COSTING_SHEET_REQUEST_FOR_RECOSTING',
	COSTING_SHEET_UPDATE_BASE_PRICE: 'COSTING_SHEET_UPDATE_BASE_PRICE',
	COSTING_SHEET_UPDATE_PRICE: 'COSTING_SHEET_UPDATE_PRICE',
	COSTING_SHEET_UPDATE_REMARKS: 'COSTING_SHEET_UPDATE_REMARKS',
	MENU_DASHBOARD: 'MENU_DASHBOARD',
	MENU_QUOTES: 'MENU_QUOTES',
	MENU_ORDERS: 'MENU_ORDERS',
	MENU_NITEX_STUDIO: 'MENU_NITEX_STUDIO',
	MENU_COLLECTIONS: 'MENU_COLLECTIONS',
	MENU_INITIAL_COSTING: 'MENU_INITIAL_COSTING',
	MENU_RECOSTING: 'MENU_RECOSTING',
	SETTING_GET_GENERAL_SETTING: 'SETTING_GET_GENERAL_SETTING',
	MENU_SAMPLE: 'MENU_SAMPLE',
	MENU_PHOTOGRAPHY: 'MENU_PHOTOGRAPHY',
	MENU_PENDING_REQUESTS: 'MENU_PENDING_REQUESTS',
	MENU_MANAGE_REPORT: 'MENU_MANAGE_REPORT',
	MENU_SETTINGS: 'MENU_SETTINGS',
	MENU_SUPPLIER: 'MENU_SUPPLIER',
	MENU_MATERIAL: 'MENU_MATERIAL',
	MENU_CRM: 'MENU_CRM',
	COSTING_SHOW_PRICE_IN_DESIGN: 'COSTING_SHOW_PRICE_IN_DESIGN',
	MENU_ASSETS: 'MENU_ASSETS',
	MENU_CONFIGURATION: 'MENU_CONFIGURATION',
	MENU_TREND_RESEARCH: 'MENU_TREND_RESEARCH',
	MENU_MOOD_BOARD: 'MENU_MOOD_BOARD',
	MENU_MANAGE_USERS: 'MENU_MANAGE_USERS',
	MENU_MANAGE_ADMIN: 'MENU_MANAGE_ADMIN',
	MENU_MANAGE_CLIENT: 'MENU_MANAGE_CLIENT',
	MENU_MANAGE_ROLE: 'MENU_MANAGE_ROLE',
	MENU_MANAGE_BRAND: 'MENU_MANAGE_BRAND',
	MENU_MANAGE_SERVICES: 'MENU_MANAGE_SERVICES',
	MENU_MANAGE_DESIGN: 'MENU_MANAGE_DESIGN',
	MENU_MANAGE_ORDER: 'MENU_MANAGE_ORDER',
	MENU_MANAGE_INVOICE: 'MENU_MANAGE_INVOICE',
	MENU_MANAGE_COLLECTION: 'MENU_MANAGE_COLLECTION',
	MENU_MANAGE_TASK: 'MENU_MANAGE_TASK',
	MENU_MANAGE_BOOHOO_PO: 'MENU_MANAGE_BOOHOO_PO',
	MENU_MANAGE_ASSETS: 'MENU_MANAGE_ASSETS',
	MENU_MANAGE_CONFIGURATION: 'MENU_MANAGE_CONFIGURATION',
	MENU_MANAGE_SAMPLE: 'MENU_MANAGE_SAMPLE',
	MENU_MY_DASHBOARD: 'MENU_MY_DASHBOARD'
};

export const ROUTES = {
	MENU_DASHBOARD: '/dashboard',
	MENU_NITEX_STUDIO: '/nitex-studio',
	MENU_COLLECTIONS: '/collections/list',
	MENU_SAMPLE: '/sample/all',
	MENU_PHOTOGRAPHY: '/photography/all',
	MENU_MATERIAL: '/materials/view',
	MENU_DESIGNS: '/collections/list',
	MENU_ORDERS: '/orders/my-orders?active=ORDER_DASHBOARD',
	MENU_QUOTES: '/costing/initial',
	MENU_PENDING_REQUESTS: '/buyer-requests',
	MENU_SUPPLIER: '/suppliers/view',
	MENU_CRM: '/crm',
	MENU_ASSETS: '/assets?activeTab=BLOCK_LIBRARY',
	MENU_CONFIGURATION: '/configuration',
	MENU_TREND_RESEARCH: '/trends',
	MENU_MOOD_BOARD: '/moodboards',
	MENU_ADMIN_LIST: '/admins/list',
	MENU_CLIENT_LIST: '/clients/list',
	MENU_BRAND_LIST: '/brands/list',
	MENU_REPORTS: '/reports',
	MENU_LIBRARY_CONFIGURATION: '/configuration',
	MENU_MATERIAL_REQUISITION: '/materials/requisition?activeTab=FABRIC',
	MENU_BUYERS_ACTIVITY: '/buyers-activity',
	MENU_BRANDS_ACTIVITY: '/brands-activity',
	MENU_MY_DASHBOARD: '/my-dashboard'
};

const materialSubMenu = [
	{
		label: 'Core Fabric Library',
		to: `${ROUTES.MENU_MATERIAL}?requestFor=MATERIAL_CORE_FABRIC`,
		permissions: [PERMISSIONS.MENU_MATERIAL],
		key: 'coreFabricLibrary'
	},
	{
		label: 'Material Inventory',
		to: `${ROUTES.MENU_MATERIAL}?requestFor=MATERIAL_INVENTORY`,
		permissions: [PERMISSIONS.MENU_MATERIAL],
		key: 'materialInventory'
	},
	{
		label: 'Material Catalog',
		to: `${ROUTES.MENU_MATERIAL}?requestFor=MATERIAL_CATALOG`,
		permissions: [PERMISSIONS.MENU_MATERIAL],
		key: 'materialCatalog'
	},
	{
		label: 'Material Requisition',
		to: `${ROUTES.MENU_MATERIAL_REQUISITION}`,
		permissions: [PERMISSIONS.MENU_MATERIAL],
		key: 'materialRequisition'
	}
];

const nitexStudioSubMenu = [
	{
		label: 'Published',
		to: `${ROUTES.MENU_NITEX_STUDIO}?designType=PUBLISHED`,
		permissions: [PERMISSIONS.MENU_NITEX_STUDIO],
		key: 'published'
	},
	{
		label: 'Sold',
		to: `${ROUTES.MENU_NITEX_STUDIO}?designType=SOLD`,
		permissions: [PERMISSIONS.MENU_NITEX_STUDIO],
		key: 'sold'
	}
];

const brandsSubMenu = [
	{
		label: 'Brands List',
		to: ROUTES.MENU_BRAND_LIST,
		permissions: [PERMISSIONS.MENU_MANAGE_USERS, PERMISSIONS.MENU_MANAGE_BRAND],
		key: 'brands'
	},
	{
		label: 'Brands Activity',
		to: ROUTES.MENU_BRANDS_ACTIVITY,
		permissions: [PERMISSIONS.MENU_MANAGE_USERS, PERMISSIONS.MENU_MANAGE_BRAND],
		key: 'brands'
	}
];

export const ALL_TOP_BAR_MENUS = [
	{
		key: 'MENU_DASHBOARD',
		permission: PERMISSIONS.MENU_DASHBOARD,
		route: ROUTES.MENU_DASHBOARD,
		activeTabKey: 'dashboard',
		title: checkUserType('COMMERCIAL') ? 'Commercial' : 'Dashboard'
	},
	{
		key: 'MENU_COLLECTIONS',
		permission: PERMISSIONS.MENU_COLLECTIONS,
		route: ROUTES.MENU_COLLECTIONS,
		activeTabKey: 'collections',
		title: 'Collections'
	},
	{
		key: 'MENU_MATERIAL',
		permission: PERMISSIONS.MENU_MATERIAL,
		activeTabKey: 'materials',
		title: 'Materials',
		route: '#',
		subMenus: [...materialSubMenu]
	},
	{
		key: 'MENU_SAMPLE',
		permission: PERMISSIONS.MENU_SAMPLE,
		route: ROUTES.MENU_SAMPLE,
		activeTabKey: 'sample',
		title: 'Sample'
	},
	{
		key: 'MENU_PHOTOGRAPHY',
		permission: PERMISSIONS.MENU_PHOTOGRAPHY,
		route: ROUTES.MENU_PHOTOGRAPHY,
		activeTabKey: 'photography',
		title: 'Photoshoot'
	},
	{
		key: 'MENU_NITEX_STUDIO',
		permission: PERMISSIONS.MENU_NITEX_STUDIO,
		// route: ROUTES.MENU_NITEX_STUDIO,
		activeTabKey: 'nitex-studio',
		title: 'Nitex Studio',
		route: '#',
		subMenus: [...nitexStudioSubMenu]
	},
	{
		key: 'MENU_ORDERS',
		permission: PERMISSIONS.MENU_ORDERS,
		route: ROUTES.MENU_ORDERS,
		activeTabKey: 'orders',
		title: 'Orders'
	},
	{
		key: 'MENU_QUOTES',
		permission: PERMISSIONS.MENU_QUOTES,
		route: ROUTES.MENU_QUOTES,
		activeTabKey: 'costing',
		title: 'Costing'
	},
	{
		key: 'MENU_PENDING_REQUESTS',
		permission: PERMISSIONS.MENU_PENDING_REQUESTS,
		route: ROUTES.MENU_PENDING_REQUESTS,
		activeTabKey: 'buyer-requests',
		title: 'Pending Requests'
	},
	{
		key: 'MENU_SUPPLIER',
		permission: PERMISSIONS.MENU_SUPPLIER,
		route: ROUTES.MENU_SUPPLIER,
		activeTabKey: 'suppliers',
		title: 'Suppliers'
	},
	{
		key: 'MENU_CRM',
		permission: PERMISSIONS.MENU_CRM,
		route: ROUTES.MENU_CRM,
		activeTabKey: 'crm',
		title: 'CRM'
	},
	{
		key: 'MENU_ASSETS',
		permission: PERMISSIONS.MENU_ASSETS,
		route: ROUTES.MENU_ASSETS,
		activeTabKey: 'assets',
		title: 'Assets'
	},
	{
		key: 'MENU_CONFIGURATION',
		permission: PERMISSIONS.MENU_CONFIGURATION,
		route: ROUTES.MENU_CONFIGURATION,
		activeTabKey: 'configuration',
		title: 'Configuration'
	},
	{
		key: 'MENU_TREND_RESEARCH',
		permission: PERMISSIONS.MENU_TREND_RESEARCH,
		route: ROUTES.MENU_TREND_RESEARCH,
		activeTabKey: 'trends',
		title: 'Trends'
	},
	{
		key: 'MENU_MOOD_BOARD',
		permission: PERMISSIONS.MENU_MOOD_BOARD,
		route: ROUTES.MENU_MOOD_BOARD,
		activeTabKey: 'moodboards',
		title: 'Mood Board'
	},
	{
		key: 'MENU_MY_DASHBOARD',
		permission: PERMISSIONS.MENU_MY_DASHBOARD,
		route: ROUTES.MENU_MY_DASHBOARD,
		activeTabKey: 'my-dashboard',
		title: 'My Dashboard'
	}
];

export const TOP_BAR_MORE_MENUS = [
	{
		label: 'Admins',
		to: ROUTES.MENU_ADMIN_LIST,
		permissions: [PERMISSIONS.MENU_MANAGE_USERS, PERMISSIONS.MENU_MANAGE_ADMIN],
		key: 'admins'
	},
	{
		label: 'Buyer',
		to: ROUTES.MENU_CLIENT_LIST,
		permissions: [PERMISSIONS.MENU_MANAGE_USERS, PERMISSIONS.MENU_MANAGE_CLIENT],
		key: 'clients'
	},
	{
		label: 'Buyer activity',
		to: ROUTES.MENU_BUYERS_ACTIVITY,
		permissions: [],
		key: 'buyerActivity',
		customPermissionType: 'ADMIN_OR_ACCOUNT_MANAGER'
	},
	{
		label: 'Brands',
		to: '#',
		permissions: [PERMISSIONS.MENU_MANAGE_USERS, PERMISSIONS.MENU_MANAGE_BRAND],
		key: 'brands',
		subMenus: [...brandsSubMenu]
	},
	{
		label: 'Sample',
		to: ROUTES.MENU_SAMPLE,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_MANAGE_SAMPLE],
		key: 'sample'
	},
	{
		label: 'Pending requests',
		to: ROUTES.MENU_PENDING_REQUESTS,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_PENDING_REQUESTS],
		key: 'pendingRequests'
	},
	{
		label: 'Costing',
		to: ROUTES.MENU_QUOTES,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_QUOTES],
		key: 'costing'
	},
	{
		label: 'Orders',
		to: ROUTES.MENU_ORDERS,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_ORDERS],
		key: 'orders'
	},
	{
		label: 'Trends',
		to: ROUTES.MENU_TREND_RESEARCH,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_TREND_RESEARCH],
		key: 'trends'
	},
	{
		label: 'Mood Board',
		to: ROUTES.MENU_MOOD_BOARD,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_MOOD_BOARD],
		key: 'moodboards'
	},
	{
		label: 'Collections',
		to: ROUTES.MENU_DESIGNS,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_MANAGE_COLLECTION],
		key: 'collections'
	},
	{
		label: 'Materials',
		to: '#',
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_MATERIAL],
		key: 'materials',
		subMenus: [...materialSubMenu]
	},
	{
		label: 'Suppliers',
		to: ROUTES.MENU_SUPPLIER,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_SUPPLIER],
		key: 'suppliers'
	},
	{
		label: 'Reports',
		to: ROUTES.MENU_REPORTS,
		permissions: [PERMISSIONS.MENU_MANAGE_SERVICES, PERMISSIONS.MENU_MANAGE_REPORT],
		key: 'reports'
	},
	{
		label: 'Assets',
		to: ROUTES.MENU_ASSETS,
		permissions: [PERMISSIONS.MENU_MANAGE_ASSETS],
		key: 'assets'
	},
	{
		label: 'Configuration',
		to: ROUTES.MENU_LIBRARY_CONFIGURATION,
		permissions: [PERMISSIONS.MENU_MANAGE_CONFIGURATION],
		key: 'configuration'
	},
	{
		label: 'My Dashboard',
		to: ROUTES.MENU_MY_DASHBOARD,
		permissions: [PERMISSIONS.MENU_MY_DASHBOARD],
		key: 'my-dashboard'
	}
];

export const TAGS_TYPE = {
	MATERIAL_SUSTAINABLE_TAG: 'MATERIAL_SUSTAINABLE_TAG',
	SUPPLIER_STRENGTH: 'SUPPLIER_STRENGTH',
	SUPPLIER_ADDITIONAL_TAG: 'SUPPLIER_ADDITIONAL_TAG',
	SUPPLIER_CLIENTS: 'SUPPLIER_CLIENTS'
};

export const MATERIALS_TYPE = {
	GARMENTS: 'GARMENTS',
	FABRIC: 'FABRIC',
	MAIN_FABRIC: 'MAIN_FABRIC',
	EXTRA_FABRIC: 'EXTRA_FABRIC',
	EMBELLISHMENT: 'EMBELLISHMENT',
	TRIMS_ACCESSORIES: 'TRIMS_ACCESSORIES',
	BRANDING: 'BRANDING',
	WASHING: 'WASHING',
	TRIMS: 'TRIMS',
	ACCESSORIES: 'ACCESSORIES',
	DESIGN_FABRIC: 'DESIGN_FABRIC'
};

export const MATERIAL_TYPE = {
	GARMENT: 'GARMENT',
	MAIN_FABRIC: 'MAIN_FABRIC',
	EMBELLISHMENT: 'EMBELLISHMENT',
	TRIMS: 'TRIMS',
	BRANDING: 'BRANDING',
	ACCESSORIES: 'ACCESSORIES',
	LIBRARY_FABRIC: 'LIBRARY_FABRIC',
	WASHING_PROCESS: 'WASHING_PROCESS'
};

export const DEFAULT_SIZECATEGORY = {
	id: 1,
	name: 'Standard'
};

export const LIST_VIEW_TYPE = {
	LARGE_VIEW: 'LARGE_VIEW',
	NARROW_VIEW: 'NARROW_VIEW',
	IMAGE_VIEW: 'IMAGE_VIEW',
	LIST_VIEW: 'LIST_VIEW',
	CARD_VIEW: 'CARD_VIEW',
	COLLECTION_VIEW: 'COLLECTION_VIEW'
};

export const VALID_FILE_SIZE = 150582912; // in binary 150mb
export const MOODBAOD_PRESENTATION_IMAGE_SIZE = 5242880; // in binary 5mb
export const MOODBAOD_IMAGE_SIZE = 2097152; // in binary 2mb

export const PANTONE_OR_HEX_CODE = 'PANTONE_OR_HEX_CODE';
export const SWATCH = 'SWATCH';

export { HTTP_STATUS };

export const getSocketChannel = (userId) => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return `/topic/production-user-${userId}`;
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return `/topic/demo-user-${userId}`;
	} else {
		return `/topic/test-user-${userId}`;
	}
};

export const getCloudFrontUrl = () => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return 'https://d9nbihbmjte73.cloudfront.net';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'https://d36qt47vlb2ajr.cloudfront.net';
	} else {
		return 'https://d2939dhdpmjcbe.cloudfront.net';
	}
};

export const getFileStorageUrl = () => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return 'https://gcpcdn.nitex.com';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'https://filestorage-demo.nitex.com';
	} else {
		return 'https://filestorage-test.nitex.com';
	}
};

function getBaseUrl() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
		return 'https://testadmin.nitex.com/api/core';
	} else if (hostName.indexOf('https://testadmin-copy1.nitex.com') > -1) {
		return 'https://testadmin-copy1.nitex.com/api/core';
	} else if (hostName.indexOf('https://testadmin-copy2.nitex.com') > -1) {
		return 'https://testadmin-copy2.nitex.com/api/core';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://admin.nitex.com/api/core';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'https://demoadmin.nitex.com/api/core';
	} else if (hostName.indexOf('localhost') > -1) {
		// return 'https://testadmin.nitex.com/api/core';
		// return 'https://admin.nitex.com/api/core';
		// return 'https://testadmin-copy1.nitex.com/api/core';
		return 'https://testadmin-copy2.nitex.com/api/core';
		//return 'http://localhost:8443';
	}
}

function getAiBaseUrl() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
		return 'https://testjutils.nitex.ai/api';
	} else if (hostName.indexOf('https://testadmin-copy1.nitex.com') > -1) {
		return 'https://testjutils.nitex.ai/api';
	} else if (hostName.indexOf('https://testadmin-copy2.nitex.com') > -1) {
		return 'https://testjutils.nitex.ai/api';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://testjutils.nitex.ai/api';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'https://testjutils.nitex.ai/api';
	} else if (hostName.indexOf('localhost') > -1) {
		return 'https://testjutils.nitex.ai/api';
		// return 'http://localhost:8080';
	}
}

function getBaseFrontEndUrl() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
		return 'https://testadmin.nitex.com';
	} else if (hostName.indexOf('https://testadmin-copy1.nitex.com') > -1) {
		return 'https://testadmin-copy1.nitex.com';
	} else if (hostName.indexOf('https://testadmin-copy2.nitex.com') > -1) {
		return 'https://testadmin-copy2.nitex.com';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://admin.nitex.com';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'https://demoadmin.nitex.com';
	} else if (hostName.indexOf('localhost') > -1) {
		return 'http://localhost:3000';
	}
}

export const isProductionServer = () => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return true;
	}
};

export const getApprovalMaxClientId = () => {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return '15B1F2A61C84459086546BAA1EC4DB1B';
	} else {
		return '15B1F2A61C84459086546BAA1EC4DB1B';
	}
};

export function getOneSignalAppId() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://admin-beta.nitex.com') > -1) {
		return 'dc4f825e-f9ab-4e68-b720-2173adb24b9d';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'dc4f825e-f9ab-4e68-b720-2173adb24b9d';
	} else {
		return '94cae871-cc52-4805-99a4-2184250b7422';
	}
}

export function getBaseWebSocketUrl() {
	const hostName = window.location.toString();
	if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
		return 'wss://testadmin.nitex.com/api/core/ws';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'wss://admin.nitex.com/api/core/ws';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'wss://demoadmin.nitex.com/api/core/ws';
	} else if (hostName.indexOf('localhost') > -1) {
		return 'wss://testadmin.nitex.com/api/core/ws';
	} else {
		return 'wss://testadmin.nitex.com/api/core/ws';
	}
}

export const getBuyerAppBaseFrontendUrl = () => {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://app.nitex.com';
	} else {
		return 'https://test.nitex.com';
	}
};

export const supplierWorkflowSteps = {
	FACTORY_BASIC_INFORMATION: 'Factory Basic Information',
	PRODUCT_INFORMATION: 'Product Information',
	DOCUMENT_UPLOAD: 'Documents Upload',
	CAPACITY_INFORMATION: 'Capacity Information',
	BANK_INFORMATION: 'Bank Information'
};

export const supplierWorkflowFieldList = {
	FACTORY_BASIC_INFORMATION: [
		'name',
		'groupName',
		'establishmentYear',
		'factoryLocation',
		'officeLocation'
	],
	PRODUCT_INFORMATION: [
		'supplierTypeList',
		'supplierCategoryList',
		'productGroupIdList',
		'coreProductBaseTypeList',
		'productCategoryStrengthList',
		'technicalFacilities'
	],
	DOCUMENT_UPLOAD: [
		'additionalInformationDocumnetList',
		'tradeLicenseList',
		'factoryLicenseList',
		'tinCertificateList',
		'factoryCoverPhoto',
		'factoryPhotoList'
	],
	CAPACITY_INFORMATION: [
		'numberOfLine',
		'totalEmployee',
		'maleEmployeePercentage',
		'femaleEmployeePercentage',
		'knitting',
		'dyeing',
		'sewing',
		'washing',
		'sales'
	],
	BANK_INFORMATION: ['bankName', 'title', 'accountNumber', 'swiftCode', 'bankDetails', 'binNumber']
};

export const documentTypes = {
	additionalInformationDocumnetList: 'SUPPLIER_ADDITIONAL_INFORMATION',
	tradeLicenseList: 'SUPPLIER_TRADE_LICENSE',
	factoryLicenseList: 'SUPPLIER_FACTORY_LICENSE',
	tinCertificateList: 'SUPPLIER_TIN_CERTIFICATE',
	safetyDocument: 'SUPPLIER_SAFETY_DOCUMENT',
	factoryCoverPhoto: 'SUPPLIER_PHOTO_DOCUMENT',
	factoryPhotos: 'SUPPLIER_PHOTO_DOCUMENT',
	supportingDocument: 'SUPPLIER_SUPPORTING_DOCUMENT',
	supplierCertificate: 'SUPPLIER_CERTIFICATE'
};

export const TAG_COLOR_LIST = [
	'#BDD6FF',
	'#FFEAEA',
	'#FBD9C2',
	'#FEEAC1',
	'#DFF2FF',
	'#EDE3FE',
	'#D0F0FD',
	'#F4DBE6',
	'#C2F5E9',
	'#EDDBD5'
];

export const BRAND_OR_INFLUENCER_SLIDER_RESPONSIVE = [
	{ minWidth: 1520, maxWidth: 20000, slidesToShow: 8 },
	{ minWidth: 1440, maxWidth: 1519, slidesToShow: 6 },
	{ minWidth: 1365, maxWidth: 1439, slidesToShow: 5 },
	{ minWidth: 1024, maxWidth: 1364, slidesToShow: 4 },
	{ minWidth: 767, maxWidth: 1023, slidesToShow: 3 },
	{ minWidth: 500, maxWidth: 766, slidesToShow: 2 },
	{ minWidth: 0, maxWidth: 499, slidesToShow: 1 }
];

export const getSlidesToShowNumber = (windowWidth, screenList) => {
	let selectedScreen = screenList.find((item) => {
		if (item.minWidth <= windowWidth && item.maxWidth >= windowWidth) {
			return item;
		}
	});
	return selectedScreen.slidesToShow;
};

export const addressList = [
	{
		value: 'JERRY LORENZO OFFICE',
		id: 'H-87/A, R-26, Gulshan-1, Dhaka-1212, Bangladesh'
	},
	{
		value: 'VIRGIL ABLOH OFFICE',
		id: 'House-07, Road-07, Gulshan-1, Dhaka-1212, Bangladesh'
	},
	{
		value: 'UK OFFICE',
		id: 'Adansbeck Court, Commercial G Block, Studio 80, 33 Rookwood Way, London, E3 2XT'
	},
	{
		value: 'TURKEY OFFICE',
		id: 'Halkalı Merkez , Çalışkan sok. No:1/6 Küçükçekmece / İstanbul'
	},
	{
		value: 'SINGAPORE OFFICE',
		id: '160 Robinson Road, #14-04, Singapore (068914)'
	},
	{
		value: 'SPAIN OFFICE',
		id: 'Av. Diagonal 442 Bis, Entresuelo Barcelona 08036 (NIF: B70828082)'
	}
];

export const myProfilePageTabs = [
	{ name: 'PersonalInformation', label: 'Personal information' },
	{ name: 'Strength', label: 'Soft & tech skills' },
	{ name: 'ChangePassword', label: 'Change password' },
	{ name: 'EmailPreferences', label: 'Preferences' },
	{ name: 'Signature', label: 'Signature' },
	{ name: 'MyColleagues', label: 'My colleagues' }
];

export const SAMPLE_REQUEST_TYPES = {
	SEND_TO_3D: 'REQUEST_3D',
	SEND_TO_GRAPHIC: 'REQUEST_GRAPHICS',
	SEND_TO_PD_IN_HOUSE: 'SEND_TO_PD',
	SEND_TO_FACTORY_NITEX_DESIGN: 'SEND_TO_FACTORY_NITEX_DESIGN',
	SEND_TO_FACTORY_BUYER_DESIGN: 'SEND_TO_FACTORY_BUYER_DESIGN',
	SAMPLE: 'SEND_TO_SAMPLE_SECTION',
	COSTING: 'COSTING',
	TP_HANDOVER: 'TP_HANDOVER',
	TP_HANDOVER_TO_PROJECT_TEAM: 'TP_HANDOVER_TO_PROJECT_TEAM',
	TP_HANDOVER_TO_PATTERN_SECTION: 'TP_HANDOVER_TO_PATTERN_SECTION',
	TP_HANDOVER_TO_ACCOUNT_MANAGER: 'TP_HANDOVER_TO_ACCOUNT_MANAGER',
	TP_HANDOVER_TO_DESIGNER: 'TP_HANDOVER_TO_DESIGNER',
	SEND_REVISE_SAMPLE_REQUEST: 'SEND_REVISE_SAMPLE_REQUEST'
};

// PENDING( 0, "PENDING" ),
// APPROVED(1, "BUYER APPROVED"),
// COMMERCIALLY_APPROVED(2, "COMMERCIALLY APPROVED"),
// APPROVED_WITH_COMMENT(3, "APPROVED WITH COMMENT"),
// REJECTED(4, "REJECTED"),
// NOT_REQUIRED_DUE_TO_PARTIAL_DEVELOPMENT(5, "NOT REQUIRED DUE TO PARTIAL DEVELOPMENT"),
// GT_APPROVED(6, "GT APPROVED"),

export const TASK_REVIEW_STATUS = [
	{ id: 'REJECTED', value: 'Rejected', name: 'Rejected' },
	{ id: 'APPROVED', value: 'Approved', name: 'Approved' },
	{ id: 'COMMERCIALLY_APPROVED', value: 'Commercially approved', name: 'Commercially approved' },
	{ id: 'APPROVED_WITH_COMMENT', value: 'Approved with comment', name: 'Approved with comment' }
];

export const TASK_REVIEW_STATUS_NEW = [
	{ id: 'REJECTED', value: 'Rejected', name: 'Rejected' },
	{ id: 'GT_APPROVED', value: 'GT Approved', name: 'GT Approved' },
	{ id: 'COMMERCIALLY_APPROVED', value: 'GT Commercially approved', name: 'GT Commercially approved' },
	{ id: 'APPROVED_WITH_COMMENT', value: 'GT Approved with comment', name: 'GT Approved with comment' },
	{ id: 'APPROVED', value: 'Buyer approved', name: 'Buyer approved' }
];

// Used in AddTaskModal
export const WORK_COMPLEATE_LIST = [
	{ id: 'PATTERN', value: 'Pattern', name: 'Pattern' },
	{ id: 'CUTTING', value: 'Cutting', name: 'Cutting' },
	{ id: 'PRINT', value: 'Print', name: 'Print' },
	{ id: 'EMBROIDERY', value: 'Embroidery', name: 'Embroidery' },
	{ id: 'SWING', value: 'Swing', name: 'Swing' }
];

export const WAS_SAMPLE_ON_TIME = [
	{
		id: 'Yes, it arrived on time',
		value: 'Yes, it arrived on time',
		name: 'Yes, it arrived on time'
	},
	{
		id: 'It arrived, but slightly late',
		value: 'It arrived, but slightly late',
		name: 'It arrived, but slightly late'
	},
	{
		id: 'No, it was delayed',
		value: 'No, it was delayed',
		name: 'No, it was delayed'
	}
];

export const TP_OWNER_SATISFICATION_COMMENT = [
	{
		id: 'I’m very satisfied – meets expectations',
		name: 'I’m very satisfied – meets expectations',
		value: 'I’m very satisfied – meets expectations'
	},
	{
		id: 'It’s good, but needs minor improvements',
		name: 'It’s good, but needs minor improvements',
		value: 'It’s good, but needs minor improvements'
	},
	{
		id: 'Needs significant improvement',
		name: 'Needs significant improvement',
		value: 'Needs significant improvement'
	},
	{
		id: 'I didn’t like the sample',
		name: 'I didn’t like the sample',
		value: 'I didn’t like the sample'
	},
	{
		id: 'Rejected, need new sample',
		name: 'Rejected, need new sample',
		value: 'Rejected, need new sample'
	}
];

export const STAGE_START_LIST = [
	{ id: 'CUTTING', value: 'Cutting', name: 'Cutting' },
	{ id: 'PRINT', value: 'Print', name: 'Print' },
	{ id: 'EMBROIDERY', value: 'Embroidery', name: 'Embroidery' },
	{ id: 'SEWING', value: 'Sewing', name: 'Sewing' }
];

export const AUTO_COMPLETE_PREV_TASK = [
	{
		id: 'PATTERN_COMPLETED',
		label: 'Pattern completed',
		value: 'Pattern completed'
	},
	{
		id: 'CUTTING_COMPLETED',
		label: 'Cutting completed',
		value: 'Cutting completed'
	},
	{
		id: 'GT_REVIEW_NOT_REQUIRED',
		label: 'GT review not required',
		value: 'GT review not required'
	},
	{
		id: 'PRE_COSTING_NOT_REQUIRED',
		label: 'Pre costing not required',
		value: 'Pre costing not required'
	},
	{
		id: 'TP_HANDOVER_TO_PATTERN_SECTION',
		label: 'TP handover to the pattern section',
		value: 'TP handover to the pattern section'
	}
];

export const TASK_PRIORITY_OPTIONS = [
	{ id: 'STANDARD', value: 'Standard', description: 'Standard: Complete in 7 days (basic style)' },
	{ id: 'HIGH', value: 'High', description: 'High: Complete in 2 days (basic style' }
	// { id: 'EXPRESS', value: 'Express', description: 'Express: Complete on the same day (basic style)' }
];

//  PATTERN_COMPLETED(27, "ACTION", "Pattern completed" ),
//   CUTTING_COMPLETED(37, "ACTION", "Cutting completed"),
//   GT_REVIEW_NOT_REQUIRED(50, "ACTION", "GT review not required"),
//   PRE_COSTING_NOT_REQUIRED(52, "ACTION", "Pre costing not required"),
//   TP_HANDOVER_TO_PATTERN_SECTION(55, "REQUEST", "TP handover to the pattern section"),

export const CLOSE_REASON_LIST = [
	{ id: 'NITEX_COST_HIGH', value: 'Nitex costing is too high', name: 'Nitex costing is too high' },
	{ id: 'FACTORY_COST_HIGH', value: 'Factory costing is too high', name: 'Factory costing is too high' },
	{ id: 'BUYER_BUDGET_ISSUE', value: 'Buyer budget issue', name: 'Buyer budget issue' },
	{
		id: 'BUYER_BETTER_PRICE',
		value: 'Buyer received a better price from others',
		name: 'Buyer received a better price from others'
	},
	{
		id: 'TECHNICALLY_CHALLENGING',
		value: 'Style is technically challenging',
		name: 'Style is technically challenging'
	},
	{
		id: 'FACTORY_REQUIREMENTS_MISMATCH',
		value: 'Buyer’s factory requirements do not match',
		name: 'Buyer’s factory requirements do not match'
	}
];
